import { Link } from "react-router-dom";
import { FaSadTear } from "react-icons/fa";
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation("common");
  const translation = t('not_found');

  return ( 
    <div className="min-h-screen flex flex-col items-center justify-center text-center bg-gray-50 dark:bg-gray-900">
      <div className="animate-bounce text-green-500 text-6xl mb-4">
        <FaSadTear />
      </div>
      <h2 className="text-3xl font-bold text-gray-800 mb-2 animate-fade-in dark:text-white">
        {translation.heading}
      </h2>
      <p className="text-gray-600 mb-6 dark:text-white">
        {translation.message}
      </p>
      <Link 
        to="/" 
        className="px-6 py-2 bg-green-500 text-white rounded-lg shadow hover:bg-green-600 transition-all duration-300"
      >
        {translation.button_text}
      </Link>
    </div>
  );
};

export default NotFound;